import React, { useEffect, useState } from "react";
import Footer from "../Footer";
import CommonNav from "../CommonNav2";
import BuddibleSocket, { MsgIDList } from "../../lib/BuddibleSocket";
import PopupMain from "../popup/PopupMain";

import ScheduleCards from "./components/ScheduleCards";
import Services from "./components/Services";
import Kodit from "./components/Kodit";
import ShipCompNotice from "./components/ShipCompNotice";
import Partners from "./components/Partners";
import FreiscopVideos from "./components/FreiscopVideos";
import Logi_talktalk from "../Logi_talktalk";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();

const todayDateTime = +new Date();
const bgGradient = {
  startFreiscop: {
    background:
      "linear-gradient(to bottom, rgba(242,244,247,1) 0%, white 70%, rgba(255,255,255,1)) 100%",
  },
  startWhite: {
    background:
      "linear-gradient(to bottom, rgba(255, 255, 255,1)20%, rgba(242 ,244,247,1))100%",
  },
};
export default function Main2() {
  const [loginInfo, setLoginInfo] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const { i18n } = useTranslation();

  const _mClassName = "Main2";

  useEffect(() => {
    const _popupMain = localStorage.getItem("PopupMain");

    if (_popupMain === null) {
      setIsShow(true);
    }

    if (_popupMain !== null && todayDateTime >= +new Date(_popupMain)) {
      setIsShow(true);
    }
    let userInfo = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userInfo && userInfo["returnData"].length) {
      setLoginInfo(userInfo["returnData"][0]);
    }

    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        setLoginInfo(n["returnData"][0]);
      }
    );
    i18n.changeLanguage(i18n.language, (err) => {});

    return () => {
      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );
    };
  }, []);

  return (
    <>
      <CommonNav />
      {isShow && <PopupMain />}
      <main>
        {/*캐러셀*/}
        <ScheduleCards />
        <div style={{ ...bgGradient.startWhite }}>
          <Logi_talktalk />
          {/*프레이스콥 주요 서비스*/}
          <Services />
          {/*신용 정보 조회*/}
          <Kodit loginInfo={loginInfo} />
          {/*선사 항공사 공지*/}
          <ShipCompNotice />
        </div>
        <div style={{ ...bgGradient.startFreiscop }}>
          {/*제휴 파트너사*/}
          <Partners />
          {/*물류 물류 영상 센터*/}
          <FreiscopVideos />
        </div>
      </main>
      <Footer />
    </>
  );
}
